import { useEffect, useState } from 'react';

/** True once `condition` has held without a break for `ms`; false again the moment it drops. */
export const useHeldFor = (condition: boolean, ms: number): boolean => {
  const [held, setHeld] = useState(false);

  useEffect(() => {
    if (!condition) {
      setHeld(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setHeld(true), ms);
    return () => window.clearTimeout(timer);
  }, [condition, ms]);

  return held && condition;
};
